var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.chartData.title) + " ")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content", "no-padding": "" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            _vm._l(_vm.revenues, function (revenue, i) {
              return _c(
                "w-col",
                {
                  key: revenue.BookYear,
                  attrs: { xs: "6", md: _vm.colWidth, "no-margin": "" },
                },
                [
                  _c("div", { staticClass: "tiny-total" }, [
                    _vm._v(
                      " € " + _vm._s(_vm.printHumanFloat(revenue.Revenue)) + " "
                    ),
                    i != 0
                      ? _c(
                          "span",
                          {
                            staticClass: "profit",
                            class: {
                              negative:
                                _vm.getProfitPercentage(
                                  revenue.Revenue,
                                  revenue.BookYear
                                ) < 0,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getProfitPercentageAsString(
                                    revenue.Revenue,
                                    revenue.BookYear
                                  )
                                ) +
                                "% "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "year-field" }, [
                      _vm._v(" (" + _vm._s(revenue.BookYear) + ") "),
                    ]),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }